export default __webpack_public_path__ + "draggable.12e53249.svg";